import { Form, FormTheme } from '@kanda-libs/ks-component-ts';
import { Button, Loader } from '@kanda-libs/ks-design-library';
import FinanceCalculator from 'components/shared/FinanceCalculator';
import EnquiryProjectBudgetFormFieldsProjectBudget from './Fields';
import useEnquiryProjectBudgetForm from './useEnquiryProjectBudgetForm';

const EnquiryProjectBudget: React.FunctionComponent = function () {
  const { form, onSubmit, isLoading, isSubmitting, infoWorkTypes, workType } =
    useEnquiryProjectBudgetForm();
  return (
    <div className="flex flex-col gap-y-8">
      <Form id="enquiry-project-budget" form={form} onSubmit={onSubmit}>
        <FormTheme variant="streamline">
          <div className="flex flex-col gap-y-6">
            <EnquiryProjectBudgetFormFieldsProjectBudget />
            <Button.Text
              id="enquiry-work-details-submit"
              submit
              label="Next"
              variant="gradient"
              disabled={isLoading || isSubmitting}
              className="w-full"
            />
            <Loader isLoading={isSubmitting} />
          </div>
        </FormTheme>
      </Form>
      <div className="border-t border-neutral-300" />
      <FinanceCalculator
        infoWorkTypes={infoWorkTypes}
        workType={workType}
        isLoading={isLoading}
      />
    </div>
  );
};

export default EnquiryProjectBudget;
